<template>
  <div class="resume-profile-container">
    <Center :profile="profile"></Center>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Center from './Center.vue';
export default {
  components: {
    Center
  },
  computed: {
    ...mapState('editor', ['profile'])
  }
}
</script>